import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import classNames from 'classnames';
import { Fragment, forwardRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectFilterItem, unselectFilterItem } from 'actions/filters/selection';
import { createSelectedIdsSelector, createUnselectedGroupsSelector, createGroupPlaceholderSelector } from 'selectors/filter_dropdown_menu';
import { LabelName } from './item';
import ItemList from './item_list';
import { MenuActionItem, GroupHeader } from './styles';
const OtherGroup = ({
  group
}) => <GroupHeader>
    <LabelName name={group.name} isDeleted={group.deleted} />
  </GroupHeader>;
const styledPlaceholderItemCss = "s1fh16ry";
const StyledPlaceholderItem = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'li';
  return <Component ref={ref} {...restProps} className={classNames(styledPlaceholderItemCss, props.className)} />;
});
const PlaceholderItem = ({
  translationKey
}) => <StyledPlaceholderItem>
    {I18n.t(translationKey, {
    scope: 'publisher.scheduled_events.filters'
  })}
  </StyledPlaceholderItem>;
function OtherItems({
  filterName,
  group
}) {
  const dispatch = useDispatch();
  const selectedIds = useSelector(createSelectedIdsSelector(filterName));
  const placeholder = useSelector(createGroupPlaceholderSelector(filterName, group));
  function onItemChange(item, checked) {
    if (checked) {
      dispatch(selectFilterItem(filterName, group, item));
    } else {
      dispatch(unselectFilterItem(filterName, group, item));
    }
  }
  if (placeholder) {
    return <PlaceholderItem translationKey={placeholder} />;
  }
  return <ItemList groupKey={group.key} items={group.items.collection} selectedIds={selectedIds} onChange={onItemChange} />;
}
const buttonCss = "bed402a";
const Button = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(buttonCss, props.className)} />);
const ShowMoreItems = ({
  group,
  onClick
}) => {
  if (!group.items.pagination.next_page) {
    return null;
  }
  return <MenuActionItem>
      <Button onClick={onClick}>
        {I18n.t('publisher.title.show_more')}
      </Button>
    </MenuActionItem>;
};
export default function OtherGroups({
  filterName,
  onShowMore
}) {
  const groups = useSelector(createUnselectedGroupsSelector(filterName));
  if (groups.length === 0) {
    return <PlaceholderItem translationKey="no_items_found" />;
  }
  return groups.map(group => <Fragment key={group.key}>
      <OtherGroup group={group} />
      <OtherItems filterName={filterName} group={group} />
      <ShowMoreItems group={group} onClick={() => onShowMore(group)} />
    </Fragment>);
}

require("./other_groups.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./other_groups.js");